import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { RewardsBoostCampaignEntity } from "../entities/entities";

export interface RewardsBoostCampaignState {
    boostCampaign: RewardsBoostCampaignEntity | null;
}

const createInitialState = (): RewardsBoostCampaignState => ({
    boostCampaign: null,
});

@singleton()
@StoreConfig({ name: "RewardsBoostCampaignStore" })
class RewardsBoostCampaignStore extends BaseStore<RewardsBoostCampaignState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsBoostCampaignStore;
